// import React from 'react';
// import { Api } from '../../services/api';

// function Signature() {
//   const handleAuthClick = () => {
//     window.location.href = Api.API_BASE_URL  + 'auth'; // Redirect to the OAuth authorization URL
//   };

//   const handleCreateEnvelope = async () => {
//     const token = 'access_token_received_from_backend'; // Retrieve this token securely from your backend
//     const response = await fetch(Api.API_BASE_URL  +'send-envelop', {
//       method: 'POST',
//       headers: {
//         Authorization: `Bearer ${token}`,
//         'Content-Type': 'application/json',
//       },
//       body: JSON.stringify({
//         // You can send other data here if necessary
//       }),
//     });

//     const data = await response.json();
//     console.log(data); // Check the envelope creation response
//   };

//   return (
//     <div>
//       <button onClick={handleAuthClick}>Login with DocuSign</button>
//       <button onClick={handleCreateEnvelope}>Create Envelope</button>
//     </div>
//   );
// }

// export default Signature;























import React from 'react';

import { Api } from '../../services/api';

function Signature() {
  const handleAuthClick = () => {
    window.location.href =  Api.API_BASE_URL + 'auth'; // Redirect to the OAuth authorization URL
  };

  const handleCreateEnvelope = async () => {
    // const token = 'access_token_received_from_backend'; // Retrieve this token securely from your backend
    const token = localStorage.getItem('authToken');
    const response = await fetch(Api.API_BASE_URL + 'send-envelop', {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        // You can send other data here if necessary
      }),
    });

    const data = await response.json();
    console.log(data); // Check the envelope creation response
  };

  return (
    <div>
      <button onClick={handleAuthClick}>Login with DocuSign</button>
      <button onClick={handleCreateEnvelope}>Create Envelope</button>
    </div>
  );
}

export default Signature;